// extracted by mini-css-extract-plugin
export var free = "style-module--free--828e1";
export var free__container = "style-module--free__container--66610";
export var free__description = "style-module--free__description--17da5";
export var free__form = "style-module--free__form--b51de";
export var free__info = "style-module--free__info--75155";
export var free__item = "style-module--free__item--3ca18";
export var free__list = "style-module--free__list--a41c9";
export var free__title = "style-module--free__title--e7d77";
export var free__titleOrange = "style-module--free__title--orange--7b275";